import { Injectable } from '@angular/core';
import { config } from '../../_config/config';
import * as CryptoJS from 'crypto-js';
import { isEmpty, isUndefined } from '../../_utils/Common';
import { Constants } from '../../_utils/Constants';
import { SessionStorage } from './session.storage';
import { LocalStorage } from './local.storage';

@Injectable()
export class $DBManagerService {

    constructor(
        private session: SessionStorage,
        private local: LocalStorage,
    ) { }

    public set(storageType, key: string, value: any) {
        const encryptedData = this.encryptData(value);
        switch (storageType) {
            case Constants.SESSSION_STORAGE:
                this.session.set(key, encryptedData);
                break;
            case Constants.LOCAL_STORAGE:
                this.local.set(key, encryptedData);
                break;
            default:
                break;
        }
    }

    public get(storageType, key: string) {
        let data;
        switch (storageType) {
            case Constants.SESSSION_STORAGE:
                data = this.session.get(key);
                break;
            case Constants.LOCAL_STORAGE:
                data = this.local.get(key);
                break;
            default:
                break;
        }
        return this.decryptData(data);
    }

    public isExists(storageType, key: string): boolean {
        const v = this.get(storageType, key);
        return !isUndefined(v) && !isEmpty(v);
    }

    public clearDB(): void {
        console.log("clear");
        this.session.clear();
        this.local.clear();
    }

    public isDecryptValid(token: any): boolean {
        // Here Add Decryption Function & check
        if (this.decryptData(token)) { return true; }
        return false;
    }

    public encryptData(token: any): any {
        if (!config.encryption) { return token; }
        return CryptoJS.AES.encrypt(token, config.encryptionKey);
    }

    public decryptData(token: any): any {
        if (!config.encryption) { return token; }
        return CryptoJS.AES.decrypt(token.toString(), config.encryptionKey).toString(CryptoJS.enc.Utf8);
    }
}

